import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import axios from "axios";
import setAuthToken from "../../functions/auth_header";
import { getAppUrl } from "../../functions/getEnv";
const LeloCharterLinks = () => {
  const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);
  const [sessions, setSessions] = useState([]);

  useEffect(() => {
    const fetchSessions = async () => {
      try {
        if (localStorage.token) {
          setAuthToken(localStorage.token);
        }
        const response = await axios.get(`${appUrl}/api/sessions`);
        setSessions(response.data);
      } catch (error) {
        console.error("Error fetching sessions:", error.message);
      }
    };

    fetchSessions();
  }, []);

  return (
    <ul>
      {sessions
        .filter((session) => session.status === "Active")
        .map((session) => (
          <li key={session._id}>
            {/* <Link to={`/forms/${session.permalink}/${session._id}`}> */}
              {/* <div
                className="left"
                style={{
                  whiteSpace: "nowrap",
                  fontSize: "14.5px",
                  lineHeight: "50px",
                }}
              > */}
                {/* <FaIcons.FaWpforms className="menu-icon" /> */}
                {/* <span key={session._id}>Add {session.name}</span> */}
              {/* </div> */}
            {/* </Link> */}
            <Link to={`/forms/${session.permalink}`}>
              {/* <div
                className="left"
                style={{
                  whiteSpace: "nowrap",
                  fontSize: "14.5px",
                  lineHeight: "50px",
                }}
              > */}
                {/* <FaIcons.FaWpforms className="menu-icon" /> */}
                <span key={session._id}>Add {session.name}</span>
              {/* </div> */}
            </Link>
          </li>
        ))}
    </ul>
  );
};

export default LeloCharterLinks;
